import React, { useState } from 'react';
import { FaTrophy } from 'react-icons/fa';
import Header from '../common/Header';
import Footer from '../common/Footer';

const FAQPage = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 overflow-x-hidden" dir="rtl">
      {/* Header */}
      <Header />
      
      {/* FAQ Section */}
      <section id="faq" className="relative py-16 sm:py-20 lg:py-28 bg-gray-50 grid-pattern">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-primary opacity-5 rounded-full blur-3xl"></div>

        <div className="relative px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
              الأسئلة <span className="text-primary">الشائعة</span>
            </h2>
            <p className="max-w-xl mx-auto mt-4 text-lg leading-relaxed text-gray-600">
              إجابات على أكثر الأسئلة شيوعاً حول منصة نافس
            </p>
          </div>

          <div className="max-w-3xl mx-auto mt-12 md:mt-20 space-y-4">
            {[
              {
                question: "ما هي منصة نافس؟",
                answer: "نافس هي منصة تعليمية تنافسية تهدف إلى تحسين المستوى الأكاديمي للطلاب من خلال نظام مراجعة ذكي وتحديات تعليمية محفزة. نقدم بيئة تفاعلية تساعد الطلاب على المنافسة الإيجابية وتحقيق أفضل النتائج."
              },
              {
                question: "كيف يعمل نظام المنافسة في نافس؟",
                answer: "يعتمد نظام نافس على طرح أسئلة مراجعة محددة المدة، حيث يمكن للطلاب حلها خلال الوقت المحدد لجعل المراجعة أكثر إثارة وتحفيز التركيز وتحسين الأداء."
              },
              {
                question: "هل المنصة مناسبة لجميع المراحل الدراسية؟",
                answer: "نعم، تم تصميم منصة نافس لتخدم جميع المراحل الدراسية من الصف الأول إلى الصف الثاني عشر. يتم تخصيص المحتوى والتحديات حسب كل مرحلة دراسية لضمان ملائمتها لمستوى الطالب."
              },
              {
                question: "ما المميزات التي تقدمها نافس للطلاب؟",
                answer: "توفر نافس مراجعات ومحتوى تعليمي موثوق تم رفعه ومراجعته من قبل الإدارة، محتوى منظم يسهل على الطلاب المذاكرة، ونظام أسئلة محددة المدة لإضافة إثارة وتحفيز التركيز."
              }
              ,
              {
                question: "كيف يمكنني الانضمام إلى المنافسات؟",
                answer: "يمكنك الانضمام بسهولة من خلال إنشاء حساب على المنصة، ."
              },
              {
                question: "كيف يتم تقييم الأداء في المنصة؟",
                answer: "يعتمد نظام التقييم على عدة معايير تشمل: الدقة في الإجابات، سرعة الحل، المشاركة المستمرة، التقدم في المستوى، والتفوق في التحديات التنافسية."
              }
            ].map((faq, index) => (
              <div key={index} className="card-subtle rounded-2xl overflow-hidden border border-gray-200">
                <button
                  type="button"
                  className="flex items-center justify-between w-full px-6 py-5 text-right hover:bg-gray-50 transition-colors"
                  onClick={() => toggleAccordion(index)}
                >
                  <span className="text-lg font-semibold text-gray-900 text-right flex-1">{faq.question}</span>
                  <svg
                    className={`w-6 h-6 text-gray-500 transition-transform duration-300 flex-shrink-0 ${activeAccordion === index ? 'rotate-180' : ''}`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${activeAccordion === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                >
                  <div className="px-6 pb-5 border-t border-gray-100 pt-4">
                    <p className="text-gray-600 leading-relaxed text-right">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <p className="text-center text-gray-600 text-base mt-12">
            لم تجد الإجابة التي تبحث عنها؟
            <a href="#" className="font-semibold text-primary hover:text-primary-light transition-colors hover:underline mr-1">
              اتصل بالدعم
            </a>
          </p>
        </div>
      </section>

      {/* تموج فاصل قبل قسم CTA */}
      <div className="wave-section relative h-24 sm:h-32 md:h-40 overflow-hidden">
        {/* الموجة الأولى */}
        <svg className="absolute w-full h-full" preserveAspectRatio="none" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#320A6B"
            fillOpacity="1"
            d="M0,288L48,272C96,256,192,224,288,213.3C384,203,480,213,576,229.3C672,245,768,267,864,261.3C960,256,1056,224,1152,208C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
            <animate
              attributeName="d"
              dur="10s"
              repeatCount="indefinite"
              values="
          M0,288L48,272C96,256,192,224,288,213.3C384,203,480,213,576,229.3C672,245,768,267,864,261.3C960,256,1056,224,1152,208C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
          M0,256L48,245.3C96,235,192,213,288,208C384,203,480,213,576,229.3C672,245,768,267,864,277.3C960,288,1056,288,1152,272C1248,256,1344,224,1392,208L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
          M0,224L48,224C96,224,192,224,288,234.7C384,245,480,267,576,272C672,277,768,267,864,261.3C960,256,1056,256,1152,250.7C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
          M0,288L48,272C96,256,192,224,288,213.3C384,203,480,213,576,229.3C672,245,768,267,864,261.3C960,256,1056,224,1152,208C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z
        "
            />
          </path>
        </svg>

        {/* الموجة الثانية - أكثر شفافية */}
        <svg className="absolute w-full h-full" preserveAspectRatio="none" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#4C21A0"
            fillOpacity="0.6"
            d="M0,224L48,224C96,224,192,224,288,234.7C384,245,480,267,576,272C672,277,768,267,864,261.3C960,256,1056,256,1152,250.7C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
            <animate
              attributeName="d"
              dur="15s"
              repeatCount="indefinite"
              values="
          M0,224L48,224C96,224,192,224,288,234.7C384,245,480,267,576,272C672,277,768,267,864,261.3C960,256,1056,256,1152,250.7C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
          M0,288L48,282.7C96,277,192,267,288,250.7C384,235,480,213,576,208C672,203,768,213,864,208C960,203,1056,181,1152,186.7C1248,192,1344,224,1392,240L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
          M0,288L48,282.7C96,277,192,267,288,240C384,213,480,171,576,176C672,181,768,235,864,240C960,245,1056,203,1152,192C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z;
          M0,224L48,224C96,224,192,224,288,234.7C384,245,480,267,576,272C672,277,768,267,864,261.3C960,256,1056,256,1152,250.7C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z
        "
            />
          </path>
        </svg>

        {/* الموجة الثالثة - نقاط متحركة */}
        <div className="absolute w-full h-16 bottom-0 left-0" style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.2) 1px, transparent 1px) 0% 0% / 20px 20px repeat-x' }}>
          <div className="wave-dots"></div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="relative py-16 sm:py-20 bg-primary overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary-light to-primary opacity-90"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-dark-yellow opacity-10 rounded-full blur-3xl"></div>

        <div className="relative px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl text-center">
          <h2 className="text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
            جاهز لبدء رحلتك التعليمية؟
          </h2>
          <p className="max-w-2xl mx-auto mt-6 text-lg text-purple-100">
            انضم إلى آلاف الطلاب الذين حسّنوا درجاتهم وحققوا أهدافهم الأكاديمية من خلال منصتنا
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
            <a href="#" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-primary bg-white rounded-xl hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl">
              <span className="ml-2">&#x2B;</span>
              انضم الآن مجاناً
            </a>
            <a
              href="#"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white border-2 border-white rounded-xl hover:bg-white hover:text-[#6B21A8] transition-all duration-300"
            >
              <span className="ml-2">&#x25B6;</span>
              شاهد العرض التوضيحي
            </a>

          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      <style jsx>{`
        .grid-pattern {
          background-image:
            linear-gradient(rgba(50, 10, 107, 0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(50, 10, 107, 0.02) 1px, transparent 1px);
          background-size: 25px 25px;
          background-color: #f9fafb; /* نفس لون bg-gray-50 */
        }

        /* تحسينات للألوان والتباين */
        .text-primary {
          color: #320A6B;
        }

        .bg-primary {
          background-color: #320A6B;
        }

        .border-primary {
          border-color: #320A6B;
        }

        .text-dark-yellow {
          color: #B8860B;
        }

        .bg-dark-yellow {
          background-color: #B8860B;
        }

        /* تحسين التباين للنصوص على الخلفيات الملونة */
        .card-subtle {
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid rgba(0, 0, 0, 0.08);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .accordion-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .accordion-content.active {
          max-height: 500px;
        }
        
        /* تصميم قسم الموجة الفاصلة */
        .wave-section {
          position: relative;
          transform: translateY(1px); /* لإزالة الفجوة البيضاء بين الموجة والقسم التالي */
        }

        /* حركة النقاط المتحركة */
        .wave-dots {
          position: absolute;
          bottom: 0;
          width: 200%;
          height: 100%;
          background: radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 2px) 0% 0% / 20px 20px repeat-x;
          animation: moveWaveDots 15s linear infinite;
        }

        @keyframes moveWaveDots {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>

      <style jsx global>{`
        body {
          font-family: 'Cairo', sans-serif;
        }

        html {
          scroll-behavior: smooth;
        }

        /* تأكد من أن جميع النصوص مرئية */
        .text-gray-600 {
          color: #4b5563;
        }

        .text-gray-900 {
          color: #111827;
        }

        .text-white {
          color: #ffffff;
        }
      `}</style>
    </div>
  );
};

export default FAQPage;